/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import {
  type PressArticleContent,
  PressArticleContentSchema,
} from './press-article-content'

/* TypeScript */
export type PressCarouselApiProps = {
  technicalName?: Maybe<string>
  articles?: Maybe<PressArticleContent[]>
  title?: Maybe<string>
  subtitle?: Maybe<string>
}

/* Schemas */
export const PressCarouselApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  articles: z.nullish(z.array(PressArticleContentSchema)),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
})

/* Schemas validation */
type TestPressCarouselProps = ExpectTrue<
  Equal<PressCarouselApiProps, z.infer<typeof PressCarouselApiPropsSchema>>
>
